import * as PIXI from "pixi.js";


export default class AutoplayNotification extends PIXI.Container
{
    public constructor()
    {
        super();

        let bg: PIXI.Graphics = new PIXI.Graphics();
        bg.beginFill( 0x323c6a, 0.9 );
        const kHalfWidth: number = 200;
        const kHalfHeight: number = 40;
        bg.drawRoundedRect( -kHalfWidth, -kHalfHeight, kHalfWidth * 2, kHalfHeight * 2, 30 );
        bg.endFill();
        this.addChild( bg );

        let text: PIXI.Text = new PIXI.Text( "Auto-played for you", { fontFamily: "asap_regular", fontSize: 40, fill: 0xffffdf } );
        text.anchor.set( 0.5 );
        this.addChild( text );
    }
}
